import React from 'react';
import Autocomplete from '@mui/material/Autocomplete';
import { useFrontbaseAutocomplete } from './useFrontbaseAutoComplete';

export function FbAutocompleteSelect(props) {
  const propsAndHandlers = useFrontbaseAutocomplete(props);
  return <Autocomplete {...propsAndHandlers} />;
}
